/**
 * O nome da loja de um cliente (F265), para buscar no mapa e mostrar na lista.
 *
 * Na Elite o cadastro do lojista MEI vem como "59.671.142 JOAO CARLOS
 * CAMARGOS CIA (IMPERIO CELL)": a razão com o CPF/CNPJ na frente e o nome da
 * loja entre parênteses. Vale o fantasia, depois o que está entre parênteses,
 * e por último a razão sem os números.
 */
export const shopNameOf = (customer: {
  legalName: string
  tradeName: string | null
}): string => {
  if (customer.tradeName !== null && customer.tradeName.trim() !== '') {
    return customer.tradeName.trim()
  }
  const inParens = /\(([^)]+)\)\s*$/.exec(customer.legalName)?.[1]?.trim()
  if (inParens !== undefined && inParens !== '') return inParens
  return customer.legalName.replace(/[\d./-]{8,}/g, '').trim()
}
